// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/project_job_surveys.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';
import type { Timestamp, TimestampJson } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type {
  DenormalizedClient,
  DenormalizedClientJson,
  DenormalizedProject,
  DenormalizedProjectJob,
  DenormalizedProjectJobJson,
  DenormalizedProjectJson,
  DenormalizedTimeTrackingRecord,
  DenormalizedTimeTrackingRecordJson,
  DenormalizedUser,
  DenormalizedUserJson,
} from './denormalized_pb';
import { file_proto_v1_denormalized } from './denormalized_pb';
import { file_proto_v1_extension_enum } from './extension_enum_pb';
import type {
  AuditUpdater,
  AuditUpdaterJson,
  DateRange,
  DateRangeJson,
  Pagination,
  PaginationJson,
  ProjectSurveyTaskType,
  ProjectSurveyTaskTypeJson,
  ProjectSurveyTaskTypeValid,
  SortDirection,
  SortDirectionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/project_job_surveys.proto.
 */
export const file_proto_v1_project_job_surveys: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_buf_validate_validate,
      file_google_protobuf_timestamp,
      file_proto_v1_denormalized,
      file_proto_v1_extension_enum,
      file_proto_v1_type_common,
    ],
  );

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyCustomType
 */
export type ProjectSurveyCustomType =
  Message<'vmspdb.api.proto.v1.ProjectSurveyCustomType'> & {
    /**
     * @generated from field: string text = 1;
     */
    text: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyCustomType
 */
export type ProjectSurveyCustomTypeJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;
};

export type ProjectSurveyCustomTypeValid = ProjectSurveyCustomType;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyCustomType.
 * Use `create(ProjectSurveyCustomTypeSchema)` to create a new message.
 */
export const ProjectSurveyCustomTypeSchema: GenMessage<
  ProjectSurveyCustomType,
  {
    jsonType: ProjectSurveyCustomTypeJson;
    validType: ProjectSurveyCustomTypeValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 0);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized
 */
export type ProjectSurveyTaskServiceDenormalized =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
     */
    project?: DenormalizedProject;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser employees = 2;
     */
    employees: DenormalizedUser[];

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedClient client = 3;
     */
    client?: DenormalizedClient;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 5;
     */
    projectJob?: DenormalizedProjectJob;

    /**
     * @generated from field: string employee_names = 4;
     */
    employeeNames: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord time_tracking = 6;
     */
    timeTracking?: DenormalizedTimeTrackingRecord;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized
 */
export type ProjectSurveyTaskServiceDenormalizedJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProject project = 1;
   */
  project?: DenormalizedProjectJson;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.DenormalizedUser employees = 2;
   */
  employees?: DenormalizedUserJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedClient client = 3;
   */
  client?: DenormalizedClientJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedProjectJob project_job = 5;
   */
  projectJob?: DenormalizedProjectJobJson;

  /**
   * @generated from field: string employee_names = 4;
   */
  employeeNames?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord time_tracking = 6;
   */
  timeTracking?: DenormalizedTimeTrackingRecordJson;
};

export type ProjectSurveyTaskServiceDenormalizedValid =
  ProjectSurveyTaskServiceDenormalized;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized.
 * Use `create(ProjectSurveyTaskServiceDenormalizedSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceDenormalizedSchema: GenMessage<
  ProjectSurveyTaskServiceDenormalized,
  {
    jsonType: ProjectSurveyTaskServiceDenormalizedJson;
    validType: ProjectSurveyTaskServiceDenormalizedValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 1);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest
 */
export type ProjectSurveyTaskServiceGetRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest
 */
export type ProjectSurveyTaskServiceGetRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest
 */
export type ProjectSurveyTaskServiceGetRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetRequest.
 * Use `create(ProjectSurveyTaskServiceGetRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceGetRequestSchema: GenMessage<
  ProjectSurveyTaskServiceGetRequest,
  {
    jsonType: ProjectSurveyTaskServiceGetRequestJson;
    validType: ProjectSurveyTaskServiceGetRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 2);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetResponse
 */
export type ProjectSurveyTaskServiceGetResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskType[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectSurveyTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetResponse
 */
export type ProjectSurveyTaskServiceGetResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
   */
  tasks?: ProjectSurveyTaskTypeJson[];

  /**
   * @generated from field: uint32 duration = 4;
   */
  duration?: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: string client_uuid = 6;
   */
  clientUuid?: string;

  /**
   * @generated from field: repeated string employees = 7;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string notified_employees = 8;
   */
  notifiedEmployees?: string[];

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: bool completed = 11;
   */
  completed?: boolean;

  /**
   * @generated from field: bool sent = 12;
   */
  sent?: boolean;

  /**
   * @generated from field: bool unscheduled = 13;
   */
  unscheduled?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 14;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: string custom_text = 15;
   */
  customText?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
   */
  durationUnit?: DurationUnitJson;

  /**
   * @generated from field: string project_job_uuid = 17;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectSurveyTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectSurveyTaskServiceGetResponseValid =
  ProjectSurveyTaskServiceGetResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceGetResponse.
 * Use `create(ProjectSurveyTaskServiceGetResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceGetResponseSchema: GenMessage<
  ProjectSurveyTaskServiceGetResponse,
  {
    jsonType: ProjectSurveyTaskServiceGetResponseJson;
    validType: ProjectSurveyTaskServiceGetResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 3);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest
 */
export type ProjectSurveyTaskServiceCreateRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest'> & {
    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskType[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest
 */
export type ProjectSurveyTaskServiceCreateRequestJson = {
  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
   */
  tasks?: ProjectSurveyTaskTypeJson[];

  /**
   * @generated from field: uint32 duration = 4;
   */
  duration?: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: string client_uuid = 6;
   */
  clientUuid?: string;

  /**
   * @generated from field: repeated string employees = 7;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string notified_employees = 8;
   */
  notifiedEmployees?: string[];

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: bool completed = 11;
   */
  completed?: boolean;

  /**
   * @generated from field: bool sent = 12;
   */
  sent?: boolean;

  /**
   * @generated from field: bool unscheduled = 13;
   */
  unscheduled?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 14;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: string custom_text = 15;
   */
  customText?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
   */
  durationUnit?: DurationUnitJson;

  /**
   * @generated from field: string project_job_uuid = 17;
   */
  projectJobUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest
 */
export type ProjectSurveyTaskServiceCreateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest'> & {
    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskTypeValid[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateRequest.
 * Use `create(ProjectSurveyTaskServiceCreateRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceCreateRequestSchema: GenMessage<
  ProjectSurveyTaskServiceCreateRequest,
  {
    jsonType: ProjectSurveyTaskServiceCreateRequestJson;
    validType: ProjectSurveyTaskServiceCreateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 4);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse
 */
export type ProjectSurveyTaskServiceCreateResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskType[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectSurveyTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse
 */
export type ProjectSurveyTaskServiceCreateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
   */
  tasks?: ProjectSurveyTaskTypeJson[];

  /**
   * @generated from field: uint32 duration = 4;
   */
  duration?: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: string client_uuid = 6;
   */
  clientUuid?: string;

  /**
   * @generated from field: repeated string employees = 7;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string notified_employees = 8;
   */
  notifiedEmployees?: string[];

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: bool completed = 11;
   */
  completed?: boolean;

  /**
   * @generated from field: bool sent = 12;
   */
  sent?: boolean;

  /**
   * @generated from field: bool unscheduled = 13;
   */
  unscheduled?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 14;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: string custom_text = 15;
   */
  customText?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
   */
  durationUnit?: DurationUnitJson;

  /**
   * @generated from field: string project_job_uuid = 17;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectSurveyTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectSurveyTaskServiceCreateResponseValid =
  ProjectSurveyTaskServiceCreateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse.
 * Use `create(ProjectSurveyTaskServiceCreateResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceCreateResponseSchema: GenMessage<
  ProjectSurveyTaskServiceCreateResponse,
  {
    jsonType: ProjectSurveyTaskServiceCreateResponseJson;
    validType: ProjectSurveyTaskServiceCreateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 5);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest
 */
export type ProjectSurveyTaskServiceUpdateRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskType[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest
 */
export type ProjectSurveyTaskServiceUpdateRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
   */
  tasks?: ProjectSurveyTaskTypeJson[];

  /**
   * @generated from field: uint32 duration = 4;
   */
  duration?: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: string client_uuid = 6;
   */
  clientUuid?: string;

  /**
   * @generated from field: repeated string employees = 7;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string notified_employees = 8;
   */
  notifiedEmployees?: string[];

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: bool completed = 11;
   */
  completed?: boolean;

  /**
   * @generated from field: bool sent = 12;
   */
  sent?: boolean;

  /**
   * @generated from field: bool unscheduled = 13;
   */
  unscheduled?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 14;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: string custom_text = 15;
   */
  customText?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
   */
  durationUnit?: DurationUnitJson;

  /**
   * @generated from field: string project_job_uuid = 17;
   */
  projectJobUuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest
 */
export type ProjectSurveyTaskServiceUpdateRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskTypeValid[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateRequest.
 * Use `create(ProjectSurveyTaskServiceUpdateRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceUpdateRequestSchema: GenMessage<
  ProjectSurveyTaskServiceUpdateRequest,
  {
    jsonType: ProjectSurveyTaskServiceUpdateRequestJson;
    validType: ProjectSurveyTaskServiceUpdateRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 6);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateResponse
 */
export type ProjectSurveyTaskServiceUpdateResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateResponse'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string project_uuid = 2;
     */
    projectUuid: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
     */
    tasks: ProjectSurveyTaskType[];

    /**
     * @generated from field: uint32 duration = 4;
     */
    duration: number;

    /**
     * @generated from field: google.protobuf.Timestamp start_date = 5;
     */
    startDate?: Timestamp;

    /**
     * @generated from field: string client_uuid = 6;
     */
    clientUuid: string;

    /**
     * @generated from field: repeated string employees = 7;
     */
    employees: string[];

    /**
     * @generated from field: repeated string notified_employees = 8;
     */
    notifiedEmployees: string[];

    /**
     * @generated from field: string notes = 9;
     */
    notes: string;

    /**
     * @generated from field: map<string, string> attributes = 10;
     */
    attributes: { [key: string]: string };

    /**
     * @generated from field: bool completed = 11;
     */
    completed: boolean;

    /**
     * @generated from field: bool sent = 12;
     */
    sent: boolean;

    /**
     * @generated from field: bool unscheduled = 13;
     */
    unscheduled: boolean;

    /**
     * @generated from field: google.protobuf.Timestamp due_date = 14;
     */
    dueDate?: Timestamp;

    /**
     * @generated from field: string custom_text = 15;
     */
    customText: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
     */
    durationUnit: DurationUnit;

    /**
     * @generated from field: string project_job_uuid = 17;
     */
    projectJobUuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
     */
    denormalized?: ProjectSurveyTaskServiceDenormalized;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 29;
     */
    createdAt?: Timestamp;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 30;
     */
    updatedAt?: Timestamp;

    /**
     * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
     */
    updater?: AuditUpdater;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateResponse
 */
export type ProjectSurveyTaskServiceUpdateResponseJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string project_uuid = 2;
   */
  projectUuid?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskType tasks = 3;
   */
  tasks?: ProjectSurveyTaskTypeJson[];

  /**
   * @generated from field: uint32 duration = 4;
   */
  duration?: number;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: TimestampJson;

  /**
   * @generated from field: string client_uuid = 6;
   */
  clientUuid?: string;

  /**
   * @generated from field: repeated string employees = 7;
   */
  employees?: string[];

  /**
   * @generated from field: repeated string notified_employees = 8;
   */
  notifiedEmployees?: string[];

  /**
   * @generated from field: string notes = 9;
   */
  notes?: string;

  /**
   * @generated from field: map<string, string> attributes = 10;
   */
  attributes?: { [key: string]: string };

  /**
   * @generated from field: bool completed = 11;
   */
  completed?: boolean;

  /**
   * @generated from field: bool sent = 12;
   */
  sent?: boolean;

  /**
   * @generated from field: bool unscheduled = 13;
   */
  unscheduled?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 14;
   */
  dueDate?: TimestampJson;

  /**
   * @generated from field: string custom_text = 15;
   */
  customText?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.DurationUnit duration_unit = 16;
   */
  durationUnit?: DurationUnitJson;

  /**
   * @generated from field: string project_job_uuid = 17;
   */
  projectJobUuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskServiceDenormalized denormalized = 28;
   */
  denormalized?: ProjectSurveyTaskServiceDenormalizedJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.AuditUpdater updater = 31;
   */
  updater?: AuditUpdaterJson;
};

export type ProjectSurveyTaskServiceUpdateResponseValid =
  ProjectSurveyTaskServiceUpdateResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceUpdateResponse.
 * Use `create(ProjectSurveyTaskServiceUpdateResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceUpdateResponseSchema: GenMessage<
  ProjectSurveyTaskServiceUpdateResponse,
  {
    jsonType: ProjectSurveyTaskServiceUpdateResponseJson;
    validType: ProjectSurveyTaskServiceUpdateResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 7);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest
 */
export type ProjectSurveyTaskServiceDeleteRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest
 */
export type ProjectSurveyTaskServiceDeleteRequestJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;
};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest
 */
export type ProjectSurveyTaskServiceDeleteRequestValid =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;
  };

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteRequest.
 * Use `create(ProjectSurveyTaskServiceDeleteRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceDeleteRequestSchema: GenMessage<
  ProjectSurveyTaskServiceDeleteRequest,
  {
    jsonType: ProjectSurveyTaskServiceDeleteRequestJson;
    validType: ProjectSurveyTaskServiceDeleteRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 8);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteResponse
 */
export type ProjectSurveyTaskServiceDeleteResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteResponse
 */
export type ProjectSurveyTaskServiceDeleteResponseJson = {};

export type ProjectSurveyTaskServiceDeleteResponseValid =
  ProjectSurveyTaskServiceDeleteResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceDeleteResponse.
 * Use `create(ProjectSurveyTaskServiceDeleteResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceDeleteResponseSchema: GenMessage<
  ProjectSurveyTaskServiceDeleteResponse,
  {
    jsonType: ProjectSurveyTaskServiceDeleteResponseJson;
    validType: ProjectSurveyTaskServiceDeleteResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 9);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListRequest
 */
export type ProjectSurveyTaskServiceListRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceListRequest'> & {
    /**
     * @generated from field: string filter = 1;
     */
    filter: string;

    /**
     * @generated from field: uint32 page_index = 2;
     */
    pageIndex: number;

    /**
     * @generated from field: uint32 page_size = 3;
     */
    pageSize: number;

    /**
     * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
     */
    sortDirection: SortDirection;

    /**
     * @generated from field: string sort_field = 5 [deprecated = true];
     * @deprecated
     */
    sortField: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.SurveySort sort = 13;
     */
    sort: SurveySort;

    /**
     * @generated from field: string employee = 6 [deprecated = true];
     * @deprecated
     */
    employee: string;

    /**
     * @generated from field: string project = 7 [deprecated = true];
     * @deprecated
     */
    project: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.SurveyStatus status = 8;
     */
    status: SurveyStatus;

    /**
     * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
     */
    dateRange?: DateRange;

    /**
     * @generated from field: string nonce = 10;
     */
    nonce: string;

    /**
     * @generated from field: string project_uuid = 11;
     */
    projectUuid: string;

    /**
     *  optional string project_job_uuid = 12 [(buf.validate.field).string.uuid = true];
     *
     * @generated from field: string employee_uuid = 12;
     */
    employeeUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListRequest
 */
export type ProjectSurveyTaskServiceListRequestJson = {
  /**
   * @generated from field: string filter = 1;
   */
  filter?: string;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex?: number;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: vmspdb.api.proto.v1.SortDirection sort_direction = 4;
   */
  sortDirection?: SortDirectionJson;

  /**
   * @generated from field: string sort_field = 5 [deprecated = true];
   * @deprecated
   */
  sortField?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.SurveySort sort = 13;
   */
  sort?: SurveySortJson;

  /**
   * @generated from field: string employee = 6 [deprecated = true];
   * @deprecated
   */
  employee?: string;

  /**
   * @generated from field: string project = 7 [deprecated = true];
   * @deprecated
   */
  project?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.SurveyStatus status = 8;
   */
  status?: SurveyStatusJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DateRange date_range = 9;
   */
  dateRange?: DateRangeJson;

  /**
   * @generated from field: string nonce = 10;
   */
  nonce?: string;

  /**
   * @generated from field: string project_uuid = 11;
   */
  projectUuid?: string;

  /**
   *  optional string project_job_uuid = 12 [(buf.validate.field).string.uuid = true];
   *
   * @generated from field: string employee_uuid = 12;
   */
  employeeUuid?: string;
};

export type ProjectSurveyTaskServiceListRequestValid =
  ProjectSurveyTaskServiceListRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListRequest.
 * Use `create(ProjectSurveyTaskServiceListRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceListRequestSchema: GenMessage<
  ProjectSurveyTaskServiceListRequest,
  {
    jsonType: ProjectSurveyTaskServiceListRequestJson;
    validType: ProjectSurveyTaskServiceListRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 10);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListResponse
 */
export type ProjectSurveyTaskServiceListResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceListResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse items = 1;
     */
    items: ProjectSurveyTaskServiceCreateResponse[];

    /**
     * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
     */
    pagination?: Pagination;

    /**
     * @generated from field: bool degraded = 3;
     */
    degraded: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListResponse
 */
export type ProjectSurveyTaskServiceListResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskServiceCreateResponse items = 1;
   */
  items?: ProjectSurveyTaskServiceCreateResponseJson[];

  /**
   * @generated from field: vmspdb.api.proto.v1.Pagination pagination = 2;
   */
  pagination?: PaginationJson;

  /**
   * @generated from field: bool degraded = 3;
   */
  degraded?: boolean;
};

export type ProjectSurveyTaskServiceListResponseValid =
  ProjectSurveyTaskServiceListResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceListResponse.
 * Use `create(ProjectSurveyTaskServiceListResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceListResponseSchema: GenMessage<
  ProjectSurveyTaskServiceListResponse,
  {
    jsonType: ProjectSurveyTaskServiceListResponseJson;
    validType: ProjectSurveyTaskServiceListResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 11);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskOption
 */
export type ProjectSurveyTaskOption =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskOption'> & {
    /**
     * @generated from field: string label = 1;
     */
    label: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskType option_value = 2;
     */
    optionValue?: ProjectSurveyTaskType;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskOption
 */
export type ProjectSurveyTaskOptionJson = {
  /**
   * @generated from field: string label = 1;
   */
  label?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectSurveyTaskType option_value = 2;
   */
  optionValue?: ProjectSurveyTaskTypeJson;
};

export type ProjectSurveyTaskOptionValid = ProjectSurveyTaskOption;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskOption.
 * Use `create(ProjectSurveyTaskOptionSchema)` to create a new message.
 */
export const ProjectSurveyTaskOptionSchema: GenMessage<
  ProjectSurveyTaskOption,
  {
    jsonType: ProjectSurveyTaskOptionJson;
    validType: ProjectSurveyTaskOptionValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 12);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsRequest
 */
export type ProjectSurveyTaskServiceAllowedTaskOptionsRequest =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsRequest'> & {
    /**
     * @generated from field: string project_uuid = 1;
     */
    projectUuid: string;

    /**
     * @generated from field: string survey_task_uuid = 2;
     */
    surveyTaskUuid: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsRequest
 */
export type ProjectSurveyTaskServiceAllowedTaskOptionsRequestJson = {
  /**
   * @generated from field: string project_uuid = 1;
   */
  projectUuid?: string;

  /**
   * @generated from field: string survey_task_uuid = 2;
   */
  surveyTaskUuid?: string;
};

export type ProjectSurveyTaskServiceAllowedTaskOptionsRequestValid =
  ProjectSurveyTaskServiceAllowedTaskOptionsRequest;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsRequest.
 * Use `create(ProjectSurveyTaskServiceAllowedTaskOptionsRequestSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceAllowedTaskOptionsRequestSchema: GenMessage<
  ProjectSurveyTaskServiceAllowedTaskOptionsRequest,
  {
    jsonType: ProjectSurveyTaskServiceAllowedTaskOptionsRequestJson;
    validType: ProjectSurveyTaskServiceAllowedTaskOptionsRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 13);

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsResponse
 */
export type ProjectSurveyTaskServiceAllowedTaskOptionsResponse =
  Message<'vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsResponse'> & {
    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskOption options = 1;
     */
    options: ProjectSurveyTaskOption[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsResponse
 */
export type ProjectSurveyTaskServiceAllowedTaskOptionsResponseJson = {
  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskOption options = 1;
   */
  options?: ProjectSurveyTaskOptionJson[];
};

export type ProjectSurveyTaskServiceAllowedTaskOptionsResponseValid =
  ProjectSurveyTaskServiceAllowedTaskOptionsResponse;

/**
 * Describes the message vmspdb.api.proto.v1.ProjectSurveyTaskServiceAllowedTaskOptionsResponse.
 * Use `create(ProjectSurveyTaskServiceAllowedTaskOptionsResponseSchema)` to create a new message.
 */
export const ProjectSurveyTaskServiceAllowedTaskOptionsResponseSchema: GenMessage<
  ProjectSurveyTaskServiceAllowedTaskOptionsResponse,
  {
    jsonType: ProjectSurveyTaskServiceAllowedTaskOptionsResponseJson;
    validType: ProjectSurveyTaskServiceAllowedTaskOptionsResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_project_job_surveys, 14);

/**
 * @generated from enum vmspdb.api.proto.v1.DurationUnit
 */
export enum DurationUnit {
  /**
   * @generated from enum value: DURATION_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DURATION_UNIT_SECONDS = 1;
   */
  SECONDS = 1,

  /**
   * @generated from enum value: DURATION_UNIT_MINUTES = 2;
   */
  MINUTES = 2,

  /**
   * @generated from enum value: DURATION_UNIT_HOURS = 3;
   */
  HOURS = 3,

  /**
   * @generated from enum value: DURATION_UNIT_DAYS = 4;
   */
  DAYS = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.DurationUnit
 */
export type DurationUnitJson =
  | 'DURATION_UNIT_UNSPECIFIED'
  | 'DURATION_UNIT_SECONDS'
  | 'DURATION_UNIT_MINUTES'
  | 'DURATION_UNIT_HOURS'
  | 'DURATION_UNIT_DAYS';

/**
 * Describes the enum vmspdb.api.proto.v1.DurationUnit.
 */
export const DurationUnitSchema: GenEnum<DurationUnit, DurationUnitJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_project_job_surveys, 0);

/**
 * @generated from enum vmspdb.api.proto.v1.SurveyStatus
 */
export enum SurveyStatus {
  /**
   * @generated from enum value: SURVEY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SURVEY_STATUS_UNCOMPLETED = 1;
   */
  UNCOMPLETED = 1,

  /**
   * @generated from enum value: SURVEY_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: SURVEY_STATUS_UNSCHEDULED = 3;
   */
  UNSCHEDULED = 3,

  /**
   * @generated from enum value: SURVEY_STATUS_ALL = 4;
   */
  ALL = 4,
}

/**
 * @generated from enum vmspdb.api.proto.v1.SurveyStatus
 */
export type SurveyStatusJson =
  | 'SURVEY_STATUS_UNSPECIFIED'
  | 'SURVEY_STATUS_UNCOMPLETED'
  | 'SURVEY_STATUS_COMPLETED'
  | 'SURVEY_STATUS_UNSCHEDULED'
  | 'SURVEY_STATUS_ALL';

/**
 * Describes the enum vmspdb.api.proto.v1.SurveyStatus.
 */
export const SurveyStatusSchema: GenEnum<SurveyStatus, SurveyStatusJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_project_job_surveys, 1);

/**
 * @generated from enum vmspdb.api.proto.v1.SurveySort
 */
export enum SurveySort {
  /**
   * @generated from enum value: SURVEY_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SURVEY_SORT_PROJECT_NAME = 1;
   */
  PROJECT_NAME = 1,

  /**
   * @generated from enum value: SURVEY_SORT_TASKS = 2;
   */
  TASKS = 2,

  /**
   * @generated from enum value: SURVEY_SORT_PROJECT_CLIENT_NAMES = 3;
   */
  PROJECT_CLIENT_NAMES = 3,

  /**
   * @generated from enum value: SURVEY_SORT_CLIENT_NAME = 4;
   */
  CLIENT_NAME = 4,

  /**
   * @generated from enum value: SURVEY_SORT_START_DATE = 5;
   */
  START_DATE = 5,

  /**
   * @generated from enum value: SURVEY_SORT_DURATION = 6;
   */
  DURATION = 6,

  /**
   * @generated from enum value: SURVEY_SORT_NOTES = 7;
   */
  NOTES = 7,

  /**
   * @generated from enum value: SURVEY_SORT_COMPLETED = 8;
   */
  COMPLETED = 8,

  /**
   * @generated from enum value: SURVEY_SORT_ASSIGNEES = 9;
   */
  ASSIGNEES = 9,

  /**
   * @generated from enum value: SURVEY_SORT_JOB_NUMBER = 10;
   */
  JOB_NUMBER = 10,
}

/**
 * @generated from enum vmspdb.api.proto.v1.SurveySort
 */
export type SurveySortJson =
  | 'SURVEY_SORT_UNSPECIFIED'
  | 'SURVEY_SORT_PROJECT_NAME'
  | 'SURVEY_SORT_TASKS'
  | 'SURVEY_SORT_PROJECT_CLIENT_NAMES'
  | 'SURVEY_SORT_CLIENT_NAME'
  | 'SURVEY_SORT_START_DATE'
  | 'SURVEY_SORT_DURATION'
  | 'SURVEY_SORT_NOTES'
  | 'SURVEY_SORT_COMPLETED'
  | 'SURVEY_SORT_ASSIGNEES'
  | 'SURVEY_SORT_JOB_NUMBER';

/**
 * Describes the enum vmspdb.api.proto.v1.SurveySort.
 */
export const SurveySortSchema: GenEnum<SurveySort, SurveySortJson> =
  /*@__PURE__*/
  enumDesc(file_proto_v1_project_job_surveys, 2);

/**
 * @generated from service vmspdb.api.proto.v1.ProjectSurveyTaskService
 */
export const ProjectSurveyTaskService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.Create
   */
  create: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceCreateRequestSchema;
    output: typeof ProjectSurveyTaskServiceCreateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.Get
   */
  get: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceGetRequestSchema;
    output: typeof ProjectSurveyTaskServiceGetResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.Delete
   */
  delete: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceDeleteRequestSchema;
    output: typeof ProjectSurveyTaskServiceDeleteResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.Update
   */
  update: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceUpdateRequestSchema;
    output: typeof ProjectSurveyTaskServiceUpdateResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.List
   */
  list: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceListRequestSchema;
    output: typeof ProjectSurveyTaskServiceListResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.ProjectSurveyTaskService.AllowedTaskOptions
   */
  allowedTaskOptions: {
    methodKind: 'unary';
    input: typeof ProjectSurveyTaskServiceAllowedTaskOptionsRequestSchema;
    output: typeof ProjectSurveyTaskServiceAllowedTaskOptionsResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_project_job_surveys, 0);
